import { GrossIRRRowData } from './types';

export const GrossIRRRowConfig = (items: GrossIRRRowData[]) => [
  {
    largeHeader: true,
    ignoreRowCopy: true,
    className: 'table-header division-bottom-only'
  },
  ...(items || []),
];
